// Contacts list filter predicate (requester side). Isolated + pure so it is
// unit-testable without DOM. The Contacts view offers a segmented control:
//   'all'     -> every contact
//   'pending' -> only tentative "Pending Approval" contacts (awaiting the owner)
import type { MergedContact } from './merge.js';

export type ContactFilter = 'all' | 'pending';

/** matchesContactFilter decides whether a merged contact passes the active filter. */
export function matchesContactFilter(m: Pick<MergedContact, 'pendingApproval'>, filter: ContactFilter): boolean {
  if (filter === 'pending') return m.pendingApproval === true;
  return true;
}

/** filterContacts applies the active filter to a merged-contact list. */
export function filterContacts<T extends Pick<MergedContact, 'pendingApproval'>>(list: T[], filter: ContactFilter): T[] {
  return list.filter((m) => matchesContactFilter(m, filter));
}
